export class CommandManager {
  constructor() {
    this.history = [];
    this.currentIndex = -1;
  }

  executeCommand(command) {
    // Remove any commands after current index (for redo functionality)
    this.history = this.history.slice(0, this.currentIndex + 1);

    // Execute the command
    command.execute();

    // Add to history
    this.history.push(command);
    this.currentIndex += 1;
  }

  undo() {
    if (this.canUndo()) {
      const command = this.history[this.currentIndex];
      command.undo();
      this.currentIndex -= 1;
      return true;
    }
    return false;
  }

  redo() {
    if (this.canRedo()) {
      this.currentIndex += 1;
      const command = this.history[this.currentIndex];
      command.execute();
      return true;
    }
    return false;
  }

  canUndo() {
    return this.currentIndex >= 0;
  }

  canRedo() {
    return this.currentIndex < this.history.length - 1;
  }

  getHistoryInfo() {
    return {
      total: this.history.length,
      current: this.currentIndex + 1,
      canUndo: this.canUndo(),
      canRedo: this.canRedo(),
    };
  }
}
